module.exports = __webpack_public_path__ + "img/IMG_3119_L.5ed45f30.webp";